export enum GalleryLayout {
  LAYOUT1 = 'gallery_layout1',
  LAYOUT2 = 'gallery_layout2',
  LAYOUT3 = 'gallery_layout3',
  LAYOUT4 = 'gallery_layout4',
  LAYOUT5 = 'gallery_layout5',
  LAYOUT6 = 'gallery_layout6',
  LAYOUT7 = 'gallery_layout7',
  LAYOUT8 = 'gallery_layout8',
  LAYOUT9 = 'gallery_layout9',
  LAYOUT10 = 'gallery_layout10',
  LAYOUT11 = 'gallery_layout11',
  LAYOUT12 = 'gallery_layout12',
  LAYOUT13 = 'gallery_layout13',
  LAYOUT14 = 'gallery_layout14',
  LAYOUT15 = 'gallery_layout15',
  LAYOUT16 = 'gallery_layout16',
}
